import React, { useEffect, useState } from "react"
import { parsedUser } from "../../common/GetCurrentUser"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from "chart.js"
import { Bar, Line } from "react-chartjs-2"
import API from "../../common/API"
import moment from "moment"
import { FormatMoney } from "../../common/helpers"
import { Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

const TotalPlaceMonthly = props => {
  const { t } = useTranslation("global")
  const [state, setState] = useState(null)
  const [records, setRecords] = useState([])
  const user = parsedUser()
  const bindDataRemote = async () => {
    try {
      let query = `organizationId=${user?.OrganizationId || ""}`
      if (props.agent) {
        query += `&agentId=${props.agent}`
      }
      const request = await API.getAction(`dashboard/placeByMonth?${query}`)

      if (request?.data?.status === "ok") {
        setRecords(request.data.response || [])
      }
    } catch (ex) {
      console.error("Error loading placeByMonth:", ex)
    }
  }

  useEffect(() => {
    if (records) {
      const labels = records.map(item => moment(item.month).format("MMM, YYYY"))
      setState({
        labels,
        datasets: [
          {
            label: t("Places"),
            data: records.map(item => item.count),
            borderColor: "#764ba2",
            backgroundColor: "rgba(118, 75, 162, 0.1)",
            fill: true,
            tension: 0.4,
            borderWidth: 3,
            pointBackgroundColor: "#764ba2",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
            pointRadius: 5,
            pointHoverRadius: 8,
          },
        ],
      })
    }
  }, [records, t])

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  )

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          padding: 20,
          font: {
            size: 12,
            weight: "500",
          },
        },
      },
      title: {
        display: false,
        text: "Total Purchased",
      },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: "#764ba2",
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: false,
        padding: 12,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: "rgba(0, 0, 0, 0.05)",
          drawBorder: false,
        },
        ticks: {
          color: "#6c757d",
          font: {
            size: 11,
          },
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#6c757d",
          font: {
            size: 11,
          },
        },
      },
    },
    elements: {
      line: {
        tension: 0.4,
        borderWidth: 3,
        borderColor: "#764ba2",
        backgroundColor: "rgba(118, 75, 162, 0.1)",
        fill: true,
      },
      point: {
        radius: 5,
        hoverRadius: 8,
        backgroundColor: "#764ba2",
        borderColor: "#fff",
        borderWidth: 2,
      },
    },
  }
  useEffect(() => {
    bindDataRemote()
  }, [])

  useEffect(() => {
    bindDataRemote()
  }, [props.agent])

  if (!state || !records) {
    return <></>
  }

  return (
    <>
      <div className="dashboard-chart-card">
        <div className="card-header">
          <Row>
            <Col>
              <span className="card-title">{t("New places by month")}</span>
            </Col>
          </Row>
        </div>
        <div className="card-body">
          <div className="chart-container">
            <Line options={options} data={state} />
          </div>
        </div>
      </div>
    </>
  )
}

export default TotalPlaceMonthly
